export default "__VITE_ASSET__CUIAcuPu__"